import { ProductAvailableTimeSummary } from "../types/product";
import { parseBackendLocalDate } from "./formatDateAndTime";

export const isProductOrderable = (
    product: ProductAvailableTimeSummary
): boolean => {
    const now = Date.now();

    const validFrom = parseBackendLocalDate(product.validFrom);
    const validTo = parseBackendLocalDate(product.validTo);
    
    return (
        product.isActive &&
        product.isAvailable &&
        (validFrom === null || now >= validFrom) &&
        (validTo === null || now <= validTo)
    );
};